// Hook do pobierania danych prefillu modalu "Nowa oferta" – GET /sales-crm/offers/new-form-data

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface ISalesCrmOfferNewFormData {
  number: string;
  status: number;
  status_formatted: string;
}

const getSalesCrmOfferNewFormData = (): Promise<ISalesCrmOfferNewFormData> =>
  axios.get('/sales-crm/offers/new-form-data');

const QUERY_KEY = 'sales-crm-offer-new-form-data';

export const useGetSalesCrmOfferNewFormData = (
  options?: UseQueryOptions<ISalesCrmOfferNewFormData, IError>
) =>
  useQuery<ISalesCrmOfferNewFormData, IError>(
    [QUERY_KEY],
    () => getSalesCrmOfferNewFormData(),
    {
      // Brak cache – każde otwarcie modalu pobiera świeży numer, żeby uniknąć kolizji.
      cacheTime: 0,
      staleTime: 0,
      refetchOnMount: 'always',
      refetchOnWindowFocus: false,
      ...options
    }
  );
